<template>
    <div class="w-full">
        <div class="center px-2  
            xl:px-4 xl:py-3 lg:py-3 md:px-2 md:py-3">
            <div class="banner_app relative overflow-hidden w-full bg-green-100 flex flex-column xl:flex-row lg:flex-row md:flex-row 
                border-round-3xl xl:border-round-3xl lg:border-round-3xl 
                border-ios-3xl xl:border-ios-3xl lg:border-ios-2xl md:border-ios-xl sm:border-ios-xl" >
                <div class="z-0 absolute xl:block lg:block md:block
                    w-full h-full xl:w-full xl:h-full lg:w-full lg:h-full md:w-full md:h-full sm:w-6 sm:h-full 
                    right-0 bottom-0 
                    m-0 p-0
                    xl:top-0 xl:left-0 lg:top-0 lg:left-0 md:top-0 md:left-0 sm:top-0 sm:right-0
                    bg-bottom xl:bg-left-bottom lg:bg-left-bottom md:bg-left-bottom sm:bg-right
                    bg-contain xl:bg-contain lg:bg-contain md:bg-contain sm:bg-contain
                    bg-no-repeat " style="background-image: url('/images/partner_page1.png');" />
                <div class="flex flex-1" />
                <div class="flex flex-1 z-1 
                    py-5 px-5 xl:py-8 xl:px-4 lg:py-8 md:py-7 sm:py-6
                    ">
                    <div class="flex flex-column 
                        text-center xl:text-left lg:text-left md:text-left sm:text-left">
                        <span class="inline-block w-full text-green-600 
                            text-md xl:text-xl 
                            mb-2 xl:mb-3 lg:mb-3 md:mb-2 line-height-2">
                            {{ content[lang_].undertitle }}
                        </span>
                        <span class="flex w-full sm:w-6
                            text-green-600 font-bold mb-7 
                            text-3xl xl:text-6xl lg:text-5xl md:text-4xl sm:text-3xl">
                            {{ content[lang_].title }}
                        </span>
                        <div class="flex xl:hidden lg:hidden md:hidden sm:hidden height-6 py-8" ></div>
                        <div class="w-full flex flex-row">
                            <Button :label="content[lang_].agree_btn" icon="pi pi-check" @click="toShowRules()" class="p-button-lg w-full border-round-xl max-w-20rem" :loading="isLoading" severity="info"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="w-full max-w-30rem m-auto my-5">
        <span class="flex flex-column mb-3 xl:mb-4 lg:mb-3 text-lg ">
            <div class="flex mb-3 pl-5 relative">
                <div class="block absolute left-0 bg-green-200 border-circle mr-3" 
                    style="width:35px;height:35px;text-align: center;">
                    <span class="absolute text-lg text-0 left-0 font-medium top-0 w-full mt-2">1</span>
                </div>
                <span class="flex text-600 pl-4">{{ content[lang_].point1 }}</span>
            </div>
            <div class="flex mb-3 pl-5 relative">
                <div class="block absolute left-0 bg-green-200 border-circle mr-3" 
                    style="width:35px;height:35px;text-align: center;">
                    <span class="absolute text-lg text-0 left-0 font-medium top-0 w-full mt-2">2</span>
                </div>
                <span class="flex text-600 pl-4">{{ content[lang_].point2 }}</span>
            </div>
            <div class="flex mb-3 pl-5 relative">
                <div class="block absolute left-0 bg-green-200 border-circle mr-3" 
                    style="width:35px;height:35px;text-align: center;">
                    <span class="absolute text-lg text-0 left-0 font-medium top-0 w-full mt-2">3</span>
                </div>
                <span class="flex text-600 pl-4">{{ content[lang_].point3 }}</span>
            </div>
        </span>
    </div>

    <Dialog v-model:visible="showRules" :header="content[lang_].agree_title" blockScroll modal
        :style="(screen_size=='xs' || screen_size=='sm' || screen_size=='md') ? { width: '100%', height: '100%' } : { width: '75vw' }" 
        :contentStyle="(screen_size=='xs' || screen_size=='sm' || screen_size=='md') ? { height: '100%' } : { height: '500px' }"
        class="w-full max-w-30rem mx-2">
        <div class="w-full">
            <span v-for="(rule, index) of rules" :key="index"
                class="flex text-600 mb-3">
                {{ index+1 }}. {{ rule[lang_] }}
            </span>
        </div>
        <template #footer>
            <span class="w-full flex">
                <Button :label="content[lang_].be_partner_btn" icon="pi pi-check" @click="bePartner()" class="flex border-round-xl p-button-lg w-full" :loading="isLoading"/>
            </span>
        </template>
    </Dialog>
</template>

<script>
import Connect from '@/assets/js/Connect'
import Helper from '@/assets/js/Helper'
import Event from '@/assets/js/Event.js'
import { mapActions } from "vuex"
import partnerRules from '@/assets/json/partnerRules.json'

export default {
    data() {
        return {
            showRules: false,
            rules: [],
            isLoading: false,
            content: {
                ru: {
                    agree_title: 'Партнерское соглашение',
                    undertitle: 'Партнерская программа',
                    be_partner_btn: 'Стать партнером',
                    agree_btn: 'Открыть условия',
                    title: 'Зарабатывайте от 10% с каждого перевода ваших друзей',
                    subtitle: 'Получайте 10% прибыли сервиса с каждого перевода приглашенного пользователя',
                    button: 'Стать партнером',
                    point1: 'Станьте партнером и получите персональную ссылку.',
                    point2: 'Поделитесь ссылкой с вашими друзьям в соцсетях.',
                    point3: 'Получайте 10% от прибыли сервиса с каждого перевода приглашенного пользователя.',
                    create_success: 'Успех',
                    create_success_descr: 'Кошелек успешно создан',
                    create_error: 'Ошибка',
                    create_error_descr: 'Ошибка регистрации партнера'
                },
                en: {
                    agree_title: 'Partner agreement',
                    undertitle: 'Partner program',
                    be_partner_btn: 'Become a partner',
                    agree_btn: 'Open terms',
                    title: 'Earn 10% of each transfer of your friends',
                    subtitle: 'Get 10% of the service profit from each transfer of the invited user',
                    button: 'Become a partner',
                    point1: 'Become a partner and get a personal link.',
                    point2: 'Share the link with your friends on social networks.',
                    point3: 'Get 10% of the service profit from each transfer of the invited user.',
                    create_success: 'Success',
                    create_success_descr: 'Wallet successfully created',
                    create_error: 'Error',
                    create_error_descr: 'Partner registration error'
                },
            },
        }
    },
    computed: {
        lang_() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' },
        isTgApp: function () { return this.$store.getters.StateTgApp },
        screen_size() { return this.$store.getters.StateScreenSize },
        isDarkTheme() { return this.$store.getters.StateDarkTheme },
    },
    methods: {
        ...mapActions(['ActionBecomePartner']),
        loadRules() {
            this.rules = partnerRules.slice(0, 100)
        },
        toShowRules(){
            this.showRules = !this.showRules
            try { this.event.send('partnerJoin') } catch {}
        },
        async bePartner(){
            try {  this.event.send('partnerConfirm') } catch {}
            this.isLoading = true
            try {
                const become = await this.$store.dispatch('ActionBecomePartner').then(res => res)
                if(become.result && become.data){
                    this.showMess('success', this.content[this.lang_].create_success, this.content[this.lang_].create_success_descr)
                    await this.$store.dispatch('setAddGroup', 'partner').then(() => {})
                    this.event.send('partnerSuccess')
                }else{
                    this.showMess('error', this.content[this.lang_].create_error, this.content[this.lang_].create_error_descr)
                }
                this.isLoading = false
                this.showRules = false
            } catch {
                console.log('error store ActionBecomePartner')
            }
            
        },
        showMess(severity, summary, detail) {
            this.$toast.add({ severity: severity, summary: summary, detail: detail, life: 3000 });
        },
    },
    async beforeCreate() {
        this.connect = new Connect()
        this.helper = new Helper()
        this.event = new Event(this)
    },
    mounted() {
        this.helper.SetTgAppHeadColor("white", this.isDarkTheme)
        this.loadRules()
    }
}
</script>